import type { AppDispatch } from '../store';
import { apiSlice } from './apiSlice';
import { rpcSlice } from './rpcSlice';

/**
 * Clears user-scoped REST and RPC caches after the active identity changes.
 * Active subscriptions will refetch using the new token and identity key.
 */
export function resetUserScopedApiState(dispatch: AppDispatch): void {
  dispatch(apiSlice.util.resetApiState());
  dispatch(rpcSlice.util.resetApiState());
}
